<template>
	<v-menu
		ref="menu"
    :offset-x="true"
		offset-y
		:close-on-content-click="false"
		:close-on-click="false"
		:min-width="projectLineChatRoom ? 800 : 450"
		:max-width="projectLineChatRoom ? 800 : 450"
		style="background-color: red;"
		@input="onMenuToggle"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }">
					<v-btn
						v-if="iconButton"
						depressed
						:color="color"
						icon
						small
						dark
						v-bind="{ ...attrs, ...attrsTooltip }"
						v-on="{ ...on, ...onTooltip }"
					>
						<v-icon size="22">mdi-chat</v-icon>
					</v-btn>
					<v-btn
						v-else
						depressed
						:color="color"
						outlined
						small
						dark
						v-bind="{ ...attrs, ...attrsTooltip }"
						v-on="{ ...on, ...onTooltip }"
					>
						<v-icon size="22">mdi-chat</v-icon>
					</v-btn>
				</template>
				<span>{{ tooltipText }}</span>
			</v-tooltip>
		</template>

		<template>
			<div style="width: 100%; display: flex; flex: 1;">
				<!-- COLUMNA IZQUIERDA: SALA GRUPAL (45%) -->
				<div v-if="projectLineChatRoom" class="white" style="width: 45%; background: white; overflow-y: auto; border-right: 1px solid #e0e0e0; flex: 1; display: flex; flex-direction: column;">
					<!-- Header Izquierda -->
					<div style="min-height: 30px; background: #524D4D; padding: 0 12px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 10;">
						<p class="caption mb-0 font-weight-bold white--text">Chat Grupal</p>
					</div>

					<!-- SECCIÓN GRANDE: SALA GRUPAL -->
					<div class="d-flex flex-column flex-1" style="background: #FF120B; padding: 16px;"
							@click="getOrCreateProjectChatRoom">
						<div style="display: flex; align-items: flex-start; gap: 12px; margin-bottom: 12px;">
							<v-avatar color="white" size="40" style="flex-shrink: 0;">
								<v-icon size="20" color="#FF120B">mdi-account-multiple</v-icon>
							</v-avatar>
							<div style="flex-grow: 1;">
								<div class="d-flex align-center">
									<p class="mb-1 flex-grow-1" style="font-weight: 600; font-size: 13px; color: white;">
										{{ projectLineChatRoom.name || projectName || `Línea de Proyecto #${projectLineNumber}` }}
									</p>
									<v-btn
										x-small
										oulined
										color="white"
										@click.stop="getOrCreateProjectChatRoom"
									>
											<v-icon color="#FF120B" small>mdi-account-multiple</v-icon>
											<p class="mb-0 ml-1">Chatear en Grupo</p>
									</v-btn>
								</div>
								<p class="mb-0" style="font-size: 11px; color: white; font-weight: 600;">
									Chat Grupal · LP{{ projectLineNumber }} · {{ projectRoomParticipants.length }} participantes
								</p>
							</div>
						</div>

						<div style="border-radius: 4px; padding: 8px; margin-bottom: 12px;">
							<p class="mb-2" style="font-size: 10px; font-weight: 600; color: white; text-transform: uppercase; letter-spacing: 0.05em;">
								Participantes actuales ({{ filteredProjectRoomParticipants.length }})
							</p>
							<div style="max-height: 300px; overflow-y: auto;overflow-x: hidden;">
								<div
									v-for="participant in filteredProjectRoomParticipants"
									:key="'participant-' + participant.user.id"
									style="display: flex; align-items: flex-start; gap: 8px; padding: 8px 0; border-bottom: 1px solid #f0f0f0;"
								>
									<div class="d-flex align-center flex-grow-1" style="min-width: 0;">
										<img
											v-if="getUserAvatar(participant.user)"
											:src="getUserAvatar(participant.user)"
											style="height: 30px; width: 30px; border-radius: 30px; margin-right: 8px; flex-shrink: 0;"
										/>
										<v-avatar
											v-else
											color="white"
											size="30"
											class="mr-2"
											style="flex-shrink: 0;"
										>
											<span :style="{ fontSize: '10px', fontWeight: 600, color: getUserTypeColor(participant.user.userType) }">
												{{ getInitials(getFullName(participant.user)) }}
											</span>
										</v-avatar>
										<div class="flex-grow-1" style="min-width: 0;color: white;">
											<p class="mb-0 font-weight-bold caption" style="line-height: 1.3;">
												{{ getFullName(participant.user) }}											<span v-if="participant.user.id === (currentUserId || userInfo?.id)" style="margin-left: 6px; font-weight: normal;">(Tú)</span>											</p>
											<p class="mb-0" style="font-size: 10px; color: white; line-height: 1.3;">
												{{ participant.user.email }}
											</p>
										</div>
									</div>
									<v-btn
										v-if="participant.user.userType !== 'client' && participant.user.id !== (currentUserId || userInfo?.id)"
										icon
										x-small
										color="white"
										:loading="isLoading[participant.user.id]"
										:disabled="isLoading[participant.user.id]"
										@click.stop="removeUserFromRoom(participant.user.id)"
									>
										<v-icon small>mdi-trash-can</v-icon>
									</v-btn>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- COLUMNA DERECHA: USUARIOS Y SUBCONTRATISTAS (55% si existe sala grupal, 100% si no) -->
				<div :style="{ width: projectLineChatRoom ? '55%' : '100%' }" style="display: flex; flex-direction: column; overflow-y: auto;" class="white">
					<!-- Header Derecha -->
					<div style="min-height: 30px; background: #524D4D; padding: 0 12px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 10;">
						<p class="caption mb-0 font-weight-bold white--text">Usuarios y Chats</p>
						<v-btn
							icon
							x-small
							class="white--text"
							style="opacity: 0.8;"
							@click.stop="$refs.menu.isActive = false"
						>
							<v-icon small>mdi-close</v-icon>
						</v-btn>
					</div>

					<!-- SECCIÓN DE BÚSQUEDA Y FILTROS -->
					<v-list dense class="py-0">

					<!-- Cliente section (antes del búsqueda) -->
					<template v-for="group in clientGroups">
						<!-- Group label -->
						<!-- <v-subheader
							v-if="group.users.length > 0"
							:key="'header-' + group.key"
							style="height: 24px; font-size: 10px; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase; color: #999; background: #f5f5f5; padding: 0 12px;"
						>
							{{ group.label }}
						</v-subheader> -->

						<!-- Client items -->
						<v-list-item
							v-for="user in group.users"
							:key="'user-' + user.id"
							dense
							style="min-height: 42px; border-top: 1px solid #f0f0f0;"
							@click="startChat(user)"
						>
							<v-list-item-title>
								<div class="d-flex align-center justify-space-between" style="gap: 8px;">
									<div class="d-flex align-center flex-grow-1" style="min-width: 0;">
										<img
											v-if="getUserAvatar(user)"
											:src="getUserAvatar(user)"
											style="height: 26px; width: 26px; border-radius: 26px; margin-right: 8px; flex-shrink: 0;"
										/>
										<v-avatar
											v-else
											:color="getUserTypeColor(user.userType) + '22'"
											size="26"
											class="mr-2"
											style="flex-shrink: 0;"
										>
											<span :style="{ fontSize: '10px', fontWeight: 600, color: getUserTypeColor(user.userType) }">
												{{ getInitials(getFullName(user)) }}
											</span>
										</v-avatar>
										<div class="flex-grow-1" style="min-width: 0;">
											<p class="mb-0 font-weight-bold caption" style="line-height: 1.3;">
												{{ getFullName(user) }}
											</p>
											<p class="mb-0" style="font-size: 10px; color: #999; line-height: 1.3;">
												{{ user.email }}
											</p>
										</div>
									</div>
									<!-- Mostrar chips para clientes -->
									<div class="d-flex flex-column align-end" style="gap: 3px;">
										<v-chip
											x-small
											:color="getUserTypeColor(user.userType)"
											text-color="white"
										>
											{{ getUserTypeLabel(user.userType) }}
										</v-chip>
										<v-chip
											x-small
											:color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'success' : '#e0e0e0'"
											:text-color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'white' : '#999'"
										>
											{{ projectLineMessageCounts[user.id] || 0 }}
										</v-chip>
									</div>
								</div>
							</v-list-item-title>
						</v-list-item>
					</template>

					<!-- Botón para crear chat grupal (solo cuando projectLineChatRoom es null) -->
					<v-list-item
						v-if="!projectLineChatRoom"
						dense
						style="min-height: 46px; background-color: #FFF5F5; border-top: 1px solid #e0e0e0;"
					>
						<v-list-item-title>
							<div class="d-flex align-center justify-center" style="gap: 8px; width: 100%;">
								<v-btn
									small
									depressed
									color="#FF120B"
									:loading="isLoading['project-chat']"
									:disabled="isLoading['project-chat']"
									@click="createProjectChatRoom"
								>
									<v-icon small color="white">mdi-account-multiple</v-icon>
									<p class="mb-0 ml-2" style="color: white;">Crear Chat Grupal</p>
								</v-btn>
							</div>
						</v-list-item-title>
					</v-list-item>

					<div v-if="projectLineChatRoom" style="height:15px; width: 100%; background-color: #524D4D;"></div>

					<!-- Search + Segmented filter -->
					<v-list-item v-if="projectLineChatRoom" dense class="px-2 py-2" style="min-height: auto; border-bottom: 1px solid #e0e0e0;">
						<div class="d-flex flex-column" style="gap: 8px; width: 100%;">
							<v-text-field
								v-model="searchQuery"
								dense
								outlined
								hide-details
								placeholder="Buscar usuarios..."
								prepend-inner-icon="mdi-magnify"
								style="width: 100%; font-size: 11px;"
								class="search-field"
								@click.stop
								@keydown.stop
							/>
						</div>
					</v-list-item>

				<!-- Company Users Section Header (Expandible) -->
				<v-list-item
						v-if="projectLineChatRoom && filteredCompanyUsers.length > 0"
						dense
					style="min-height: 30px; background: #FFF3E0; cursor: pointer;"
					@click="expandCompanyUsers = !expandCompanyUsers"
				>
					<v-list-item-title>
						<div class="d-flex align-center justify-space-between" style="gap: 8px;">
							<div class="d-flex align-center flex-grow-1">
								<v-icon small style="margin-right: 8px; color: #FB8C00;">{{ expandCompanyUsers ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
								<p style="font-size: 12px; font-weight: 600; color: #FB8C00; margin-bottom: 0; flex-grow: 1;">Usuarios de Empresa</p>
							</div>
							<p style="font-size: 10px; font-weight: 600; color: #FB8C00; margin-bottom: 0; text-align: center; padding-right: 8px;max-width: 90px;white-space: wrap;;">
								{{ expandCompanyUsers ? 'Agregar a Chat Grupal' : 'Ver usuarios empresa' }}
							</p>
						</div>
					</v-list-item-title>
				</v-list-item>

				<!-- Company Users List (Desplegable) -->
				<template v-if="projectLineChatRoom && expandCompanyUsers">
				<v-list-item
					v-for="user in filteredCompanyUsers"
					:key="'user-' + user.id"
					dense
					style="min-height: 42px; border-top: 1px solid #f0f0f0;"
					@click="startChat(user)"
				>
					<v-list-item-title>
						<div class="d-flex align-center justify-space-between" style="gap: 8px;">
							<div class="d-flex align-center flex-grow-1 py-1" style="min-width: 0;">
								<img
									v-if="getUserAvatar(user)"
									:src="getUserAvatar(user)"
									style="height: 26px; width: 26px; border-radius: 4px; object-fit: contain; margin-right: 8px; flex-shrink: 0;"
								/>
								<v-avatar
									v-else
									:color="getUserTypeColor(user.userType) + '22'"
									size="26"
									class="mr-2"
									style="flex-shrink: 0;"
								>
									<span :style="{ fontSize: '10px', fontWeight: 600, color: getUserTypeColor(user.userType) }">
										{{ getInitials(getFullName(user)) }}
									</span>
								</v-avatar>
								<div class="flex-grow-1" style="min-width: 0;">
									<p class="mb-0 font-weight-bold caption" style="line-height: 1.3;">
										{{ getFullName(user) }}
									</p>
									<p class="mb-0" style="font-size: 10px; color: #999; line-height: 1.3;">
										{{ user.email }}
									</p>
									<v-chip
										x-small
										:color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'success' : '#e0e0e0'"
										:text-color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'white' : '#999'"
									>
										<span v-if="(projectLineMessageCounts[user.id] || 0) > 0">Conversación previa existente ({{ projectLineMessageCounts[user.id] || 0 }} mensaje {{ (projectLineMessageCounts[user.id] || 0) === 1 ? '' : 's' }} )</span>
										<span v-else>No hay conversación previa</span>
									</v-chip>
								</div>
							</div>
							<!-- Checkbox para agregar a sala grupal -->
							<div style="width: 80px; display: flex; justify-content: center;">
								<v-checkbox
									:input-value="isSubcontractorInRoom(user.id)"
									:loading="isLoading[user.id]"
									:disabled="isLoading[user.id]"
									color="black"
									dense
									style="margin: 0;"
									@change="toggleUserInRoom(user.id)"
									@click.stop
								/>
							</div>
						</div>
					</v-list-item-title>
				</v-list-item>
			</template>
			<v-subheader
				v-if="projectLineChatRoom"
				style="height: 24px; font-size: 10px; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase; color: #999; background: #f5f5f5; padding: 0 12px;"
			>
				Subcontratistas del Proyecto
			</v-subheader>
			<v-list-item
				v-if="projectLineChatRoom && visibleSubcontractorGroups.length === 0 && !searchQuery"
				dense
				style="min-height: auto;"
			>
				<v-list-item-title>
					<div style="width: 100%; padding: 12px 0;" class="d-flex flex-column align-center">
						<p style="font-size: 11px; color: #666; margin-bottom: 12px;">Aún no hay subcontratos firmados</p>
						<v-btn
							x-small
							outlined
							color="#FB8C00"
							@click="goToSubcontractPreparation"
						>
							<v-icon small style="margin-right: 4px;">mdi-pencil</v-icon>
							Ir a Preparación de Subcontratos
						</v-btn>
					</div>
				</v-list-item-title>
			</v-list-item>

			<!-- Empty state for search -->
				<v-list-item
					v-if="projectLineChatRoom && visibleSubcontractorGroups.length === 0 && searchQuery"
					dense
					disabled
					style="min-height: 40px;"
				>
					<v-list-item-title>
						<p class="mb-0 caption" style="color: #999;">No hay subcontratistas que coincidan con la búsqueda</p>
					</v-list-item-title>
				</v-list-item>

				<!-- Subcontractors Section Header -->
				<v-list-item
					v-if="projectLineChatRoom && visibleSubcontractorGroups.length > 0"
					dense
					disabled
					style="min-height: 30px;"
				>
					<v-list-item-title>
						<div class="d-flex align-center justify-space-between" style="gap: 8px;">
							<p style="font-size: 12px; font-weight: 600; color: #666; margin-bottom: 0; flex-grow: 1;">Listado Subcontratistas</p>
							<p style="font-size: 10px; font-weight: 600; color: #666; margin-bottom: 0; text-align: center; padding-right: 8px;max-width: 90px;white-space: wrap;;">Agregar a Chat Grupal</p>
						</div>
					</v-list-item-title>
				</v-list-item>

				<!-- Grouped list for subcontractors -->
				<template v-if="projectLineChatRoom">
					<template v-for="group in visibleSubcontractorGroups">

					<!-- Group label (only in "Todos") -->
					<!-- <v-subheader
						v-if="activeFilter === 'all'"
						:key="'header-' + group.key"
						style="height: 24px; font-size: 10px; font-weight: 600; letter-spacing: 0.05em; text-transform: uppercase; color: #999; background: #f5f5f5; padding: 0 12px;"
					>
						{{ group.label }}
					</v-subheader> -->

					<!-- Project room item -->
					<v-list-item
						v-if="group.key === 'project'"
						:key="'item-' + group.key"
						dense
						style="min-height: 46px; background-color: #FFF5F5; border-left: 3px solid #FF120B;"
						@click="getOrCreateProjectChatRoom"
					>
						<v-list-item-title>
							<div class="d-flex align-center justify-space-between" style="gap: 8px;">
								<div class="d-flex align-center flex-grow-1" style="min-width: 0;">
									<v-avatar color="#FF120B" size="26" class="mr-2">
										<v-icon small color="white">mdi-account-multiple</v-icon>
									</v-avatar>
									<div class="flex-grow-1" style="min-width: 0;">
										<p class="mb-0 font-weight-bold caption">
											{{ projectName || `Línea de Proyecto #${projectLineNumber}` }}
										</p>
										<p class="mb-0" style="font-size: 10px; color: #FF120B; font-weight: 600;">
											Chat Grupal · LP{{ projectLineNumber }}
										</p>
									</div>
								</div>
								<div class="d-flex flex-column align-end" style="gap: 3px;">
									<v-chip x-small color="#FF120B" text-color="white">LP{{ projectLineNumber }}</v-chip>
									<v-chip
										x-small
										:color="totalProjectLineMessageCount > 0 ? 'success' : '#e0e0e0'"
										:text-color="totalProjectLineMessageCount > 0 ? 'white' : '#999'"
									>
										{{ totalProjectLineMessageCount }}
									</v-chip>
								</div>
							</div>
						</v-list-item-title>
					</v-list-item>

					<!-- User items -->
					<v-list-item
						v-for="user in group.users"
						:key="'user-' + user.id"
						dense
						style="min-height: 42px; border-top: 1px solid #f0f0f0;"
						@click="startChat(user)"
					>
						<v-list-item-title>
							<div class="d-flex align-center justify-space-between" style="gap: 8px;">
								<div class="d-flex align-center flex-grow-1 py-1" style="min-width: 0;">
									<img
										v-if="getUserAvatar(user)"
										:src="getUserAvatar(user)"
										style="height: 26px; width: 26px; border-radius: 4px; object-fit: contain; margin-right: 8px; flex-shrink: 0;"
									/>
									<v-avatar
										v-else
										:color="getUserTypeColor(user.userType) + '22'"
										size="26"
										class="mr-2"
										style="flex-shrink: 0;"
									>
										<span :style="{ fontSize: '10px', fontWeight: 600, color: getUserTypeColor(user.userType) }">
											{{ getInitials(getFullName(user)) }}
										</span>
									</v-avatar>
									<div class="flex-grow-1" style="min-width: 0;">
										<p class="mb-0 font-weight-bold caption" style="line-height: 1.3;">
											{{ getFullName(user) }}
										</p>
										<p class="mb-0" style="font-size: 10px; color: #999; line-height: 1.3;">
											{{ user.email }}
										</p>
										<v-chip
											x-small
											:color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'success' : '#e0e0e0'"
											:text-color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'white' : '#999'"
										>
											<span v-if="(projectLineMessageCounts[user.id] || 0) > 0">Conversación previa existente ({{ projectLineMessageCounts[user.id] || 0 }} mensaje {{ (projectLineMessageCounts[user.id] || 0) === 1 ? '' : 's' }} )</span>
											<span v-else>No hay conversación previa</span>
										</v-chip>
									</div>
								</div>
								<!-- Mostrar checkbox solo para subcontratistas -->
								<div style="width: 80px; display: flex; justify-content: center;"
										v-if="user.userType === 'subcontractor' || user.userType === 'project_subcontractor'">
									<v-checkbox
										:input-value="isSubcontractorInRoom(user.id)"
										:loading="isLoading[user.id]"
										:disabled="isLoading[user.id]"
										color="black"
										dense
										style="margin: 0;"
										@change="toggleUserInRoom(user.id)"
										@click.stop
									/>
								</div>
								<!-- Mostrar chips para usuarios normales -->
								<div v-else class="d-flex flex-column align-end" style="gap: 3px;">
									<v-chip
										x-small
										:color="getUserTypeColor(user.userType)"
										text-color="white"
									>
										{{ getUserTypeLabel(user.userType) }}
									</v-chip>
									<v-chip
										x-small
										:color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'success' : '#e0e0e0'"
										:text-color="(projectLineMessageCounts[user.id] || 0) > 0 ? 'white' : '#999'"
									>
										{{ projectLineMessageCounts[user.id] || 0 }}
									</v-chip>
								</div>
							</div>
						</v-list-item-title>
					</v-list-item>

				</template>
				</template>

				</v-list>
				</div>  <!-- Cierra columna derecha -->
			</div>  <!-- Cierra flex container -->
		</template>
	</v-menu>
</template>

<script>
import { createUserChatRoom, getProjectLineMessageCounts, createProjectLineChatRoom, addUserToChatRoom, removeUserFromChatRoom } from '@/helpers/api/chats'

// const TYPE_ORDER = ['project', 'client', 'subcontractor', 'user']

const TYPE_CONFIG = {
	client:        { label: 'Cliente',         color: 'black', groupLabel: 'Cliente' },
	company_user:  { label: 'Profesional Empresa',         color: 'black', groupLabel: 'Profesionales Empresa' },
	project_subcontractor: { label: 'Subcontratista del Proyecto',   color: '#524d4d', groupLabel: 'Subcontratistas del Proyecto' },
	subcontractor: { label: 'Subcontratista',   color: '#524d4d', groupLabel: 'Subcontratistas' }
}

export default {
	name: 'UserChatSelectorMenu',
	props: {
		users: {
			type: Array,
			required: true
		},
		projectLineChatRoom: {
			type: Object,
			required: false
		},
		projectSubcontractors: {
			type: Array,
			required: false,
			default: () => []
		},
		currentUserId: {
			type: Number,
			required: false
		},
		projectLineId: {
			type: Number,
			required: false
		},
		projectLineNumber: {
			type: Number,
			required: false
		},
		projectName: {
			type: String,
			required: false
		},
		tooltipText: {
			type: String,
			default: 'Iniciar chat con un usuario'
		},
		excludeCurrentUser: {
			type: Boolean,
			default: true
		},
		excludeProjectLine: {
			type: Boolean,
			default: false
		},
		color: {
			type: String,
			default: '#959595'
		},
		iconButton: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			activeFilter: 'all',
			searchQuery: '',
			projectLineMessageCounts: {},
			totalProjectLineMessageCount: 0,
			isLoading: {},
			expandCompanyUsers: false
		}
	},
	computed: {
		userInfo() {
			return this.$store.state.user.userInfo
		},
		filterTabs() {
			return [
				{ type: 'all',           label: 'Todos' },
				{ type: 'project',       label: 'Grupal' },
				{ type: 'client',        label: 'Clientes' },
				{ type: 'project_subcontractor', label: 'Subcontratistas [Proyecto]' },
				{ type: 'subcontractor', label: 'Subcontratistas' }
			]
		},
		baseFilteredUsers() {
			if (!this.users || this.users.length === 0) return []
			return this.users.filter(user => {
				if (this.excludeCurrentUser) {
					const userId = this.currentUserId || this.userInfo?.id
					if (user.id === userId) return false
				}
				return true
			})
		},
		// Clientes sin filtrar por búsqueda
		clientUsers() {
			return this.baseFilteredUsers.filter(u => u.userType === 'client')
		},
		clientGroups() {
			const users = this.clientUsers
			if (users.length === 0) return []
			return [{ key: 'client', label: TYPE_CONFIG['client'].groupLabel, users }]
		},
		// Usuarios de empresa (filtrados por búsqueda)
		filteredCompanyUsers() {
			const companyUsers = this.baseFilteredUsers.filter(u => u.userType === 'company_user')
			const q = this.searchQuery.trim().toLowerCase()
			if (!q) return companyUsers
			return companyUsers.filter(user => {
				const name = this.getFullName(user).toLowerCase()
				return name.includes(q) || (user.email || '').toLowerCase().includes(q)
			})
		},
		// Subcontratistas filtrados por búsqueda
		filteredSubcontractorUsers() {
			const subcontractors = this.baseFilteredUsers.filter(u => 
				u.userType === 'subcontractor' || u.userType === 'project_subcontractor'
			)
			const q = this.searchQuery.trim().toLowerCase()
			if (!q) return subcontractors
			return subcontractors.filter(user => {
				const name = this.getFullName(user).toLowerCase()
				return name.includes(q) || (user.email || '').toLowerCase().includes(q)
			})
		},
		searchedUsers() {
			const q = this.searchQuery.trim().toLowerCase()
			if (!q) return this.baseFilteredUsers
			return this.baseFilteredUsers.filter(user => {
				const name = this.getFullName(user).toLowerCase()
				return name.includes(q) || (user.email || '').toLowerCase().includes(q)
			})
		},
		tabCounts() {
			const counts = { all: 0, project: 0, client: 0, project_subcontractor: 0, subcontractor: 0, user: 0 }
			if (!this.excludeProjectLine) {
				counts.project = 1
				counts.all += 1
			}
			this.baseFilteredUsers.forEach(u => {
				if (counts[u.userType] !== undefined) counts[u.userType]++
				counts.all++
			})
			return counts
		},
		projectRoomParticipants() {
			if (!this.projectLineChatRoom) {
				return []
			}
			return this.projectLineChatRoom.users || []
		},
		filteredProjectRoomParticipants() {
			// Enriquecer participantes con userType
			return this.projectRoomParticipants.map(participant => {
				// Buscar el usuario en this.users para obtener userType
				const userFromList = (this.users || []).find(u => u.id === participant.user.id)
				return {
					...participant,
					user: {
						...participant.user,
						userType: userFromList?.userType || null
					}
				}
			})
		},
		visibleSubcontractorGroups() {
			const groups = []

			// Mostrar subcontratistas filtrados por búsqueda
			const typeKeys = ['project_subcontractor', 'subcontractor']
			typeKeys.forEach(type => {
				const users = this.filteredSubcontractorUsers.filter(u => u.userType === type)
				if (users.length > 0) {
					groups.push({ key: type, label: TYPE_CONFIG[type].groupLabel, users })
				}
			})

			return groups
		},
		visibleGroups() {
			const groups = []

			// NO incluir el grupo 'project' en el listado, ahora está en la sección grande

			// User groups
			const typeKeys = Object.keys(TYPE_CONFIG)
			typeKeys.forEach(type => {
				// Excluir 'project' (está en sección grande)
				if (type === 'project') return
				if (this.activeFilter !== 'all' && this.activeFilter !== type) return
				const users = this.searchedUsers.filter(u => u.userType === type)
				if (users.length > 0) {
					groups.push({ key: type, label: TYPE_CONFIG[type].groupLabel, users })
				}
			})

			return groups
		},
		filteredAvailableSubcontractors() {
			const all = (this.users || []).filter(u => u.userType === 'subcontractor')
			const q = this.searchQuery.trim().toLowerCase()
			const filtered = !q ? all : all.filter(user => {
				const name = this.getFullName(user).toLowerCase()
				return name.includes(q) || (user.email || '').toLowerCase().includes(q)
			})
			// Ordenar mostrando primero los que YA están en la sala
			return filtered.sort((a, b) => {
				const aInRoom = this.isSubcontractorInRoom(a.id) ? 1 : 0
				const bInRoom = this.isSubcontractorInRoom(b.id) ? 1 : 0
				return bInRoom - aInRoom
			})
		},
		filteredSubcontractors() {
			const all = (this.users || []).filter(u => u.userType === 'subcontractor')
			const q = this.searchQuery.trim().toLowerCase()
			if (!q) return all
			return all.filter(user => {
				const name = this.getFullName(user).toLowerCase()
				return name.includes(q) || (user.email || '').toLowerCase().includes(q)
			})
		}
	},
	watch: {
		projectLineId(newVal) {
			if (newVal) this.fetchProjectLineMessageCounts()
		}
	},
	mounted() {
		if (this.projectLineId) this.fetchProjectLineMessageCounts()

		console.log('projectSubcontractors in UserChatSelectorMenus:', this.projectSubcontractors)
	},
	methods: {
		async fetchProjectLineMessageCounts() {
			if (!this.projectLineId || !this.baseFilteredUsers.length) return
			try {
				const users_id = this.baseFilteredUsers.map(u => u.id)
				const response = await getProjectLineMessageCounts({
					project_line_id: this.projectLineId,
					users_id
				})
				if (response && response.code === 200) {
					this.projectLineMessageCounts = response.message_counts || {}
					this.totalProjectLineMessageCount = response.pl_message_count || 0
				}
			} catch (error) {
				console.error('Error fetching project line message counts:', error)
			}
		},
		getInitials(name) {
			if (!name) return '?'
			return name.split(' ').map(w => w.charAt(0).toUpperCase()).slice(0, 2).join('')
		},
		getUserAvatar(user) {
			return user?.profile?.avatar || user?.avatar
		},
		getFullName(user) {
			const profile = user?.profile || user
			return [profile?.name, profile?.lastname, profile?.second_lastname]
				.filter(Boolean)
				.join(' ')
		},
		getUserTypeLabel(userType) {
			return TYPE_CONFIG[userType]?.label || 'Usuario'
		},
		getUserTypeColor(userType) {
			return TYPE_CONFIG[userType]?.color || '#959595'
		},
		async startChat(user) {
			try {
				if (this.excludeCurrentUser && user.id === (this.currentUserId || this.userInfo?.id)) {
					this.$store.dispatch('setMessage', {
						message: 'No puedes iniciar un chat con tu propia cuenta.',
						title: 'Operación no permitida',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209'
					})
					return
				}
				const userChat = await createUserChatRoom({ user_id: user.id })
				if (userChat && userChat.code === 200 && userChat.chat_room) {
					const room_to_chat = {
						...userChat.chat_room,
						project_line_id: this.projectLineId
					}
					this.$store.commit('general/addChatRoomCenter', room_to_chat)
				} else {
					this.$store.dispatch('setMessage', {
						message: 'No fue posible crear la sala de chat. Intenta nuevamente.',
						title: 'Error al crear chat',
						type: 'danger',
						icon: 'mdi-alert-circle',
						color: '#FF1209'
					})
				}
			} catch (error) {
				console.error('Error al iniciar chat:', error)
				this.$store.dispatch('setMessage', {
					message: error.message || 'Error desconocido al iniciar el chat',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-alert-circle',
					color: '#FF1209'
				})
			}
		},
		async getOrCreateProjectChatRoom() {
			const project_chat = await createProjectLineChatRoom({ project_line_id: this.projectLineId })
			if (project_chat.code === 200) {
				this.$store.commit('general/addChatRoomCenter', project_chat.chat_room)
			}
		},
		isSubcontractorInRoom(userId) {
			return this.projectRoomParticipants.some(p => p.user && p.user.id === userId)
		},
		async toggleUserInRoom(userId) {
			this.$set(this.isLoading, userId, true)
			try {
				if (this.isSubcontractorInRoom(userId)) {
					// Remover usuario de la sala
					await removeUserFromChatRoom({
						chat_room_id: this.projectLineChatRoom.id,
						users_id: [userId]
					})
					this.$store.dispatch('setMessage', {
						message: 'Usuario removido de la sala grupal',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#00C800'
					})
				} else {
					// Agregar usuario a la sala - enviar todos los participantes actuales + el nuevo
					const currentUserIds = this.projectRoomParticipants.map(p => p.user.id)
					const allUserIds = [...currentUserIds, userId]
					await addUserToChatRoom({
						chat_room_id: this.projectLineChatRoom.id,
						users_id: allUserIds
					})
					this.$store.dispatch('setMessage', {
						message: 'Usuario agregado a la sala grupal',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#00C800'
					})
				}
				// Emitir evento para que parent refresque los datos
				this.$emit('user-room-updated')
			} catch (error) {
				console.error('Error al actualizar usuario en la sala:', error)
				this.$store.dispatch('setMessage', {
					message: error.message || 'Error al actualizar usuario en la sala',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-alert-circle',
					color: '#FF1209'
				})
			} finally {
				this.$set(this.isLoading, userId, false)
			}
		},
		async removeUserFromRoom(userId) {
			this.$set(this.isLoading, userId, true)
			try {
				await removeUserFromChatRoom({
					chat_room_id: this.projectLineChatRoom.id,
					users_id: [userId]
				})
				this.$store.dispatch('setMessage', {
					message: 'Usuario removido de la sala grupal',
					title: 'Éxito',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#00C800'
				})
				// Emitir evento para que parent refresque los datos
				this.$emit('user-room-updated')
			} catch (error) {
				console.error('Error al remover usuario de la sala:', error)
				this.$store.dispatch('setMessage', {
					message: error.message || 'Error al remover usuario de la sala',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-alert-circle',
					color: '#FF1209'
				})
			} finally {
				this.$set(this.isLoading, userId, false)
			}
		},
		onMenuToggle(isOpen) {
			// Si el menú se cierra, resetear al estado inicial con un delay
			if (!isOpen) {
				setTimeout(() => {
					this.searchQuery = ''
				}, 150)
			}
		},
		goToSubcontractPreparation() {
			// TODO: Implementar navegación a preparación de subcontratos
			console.log('Navegar a preparación de subcontratos')
			this.$router.push({ hash: '#external' })
			this.$refs.menu.isActive = false
		},
		async createProjectChatRoom() {
			this.$set(this.isLoading, 'project-chat', true)
			try {
				const project_chat = await createProjectLineChatRoom({ project_line_id: this.projectLineId })
				if (project_chat && project_chat.code === 200) {
					// Solo emitir evento sin hacer commit
					this.$emit('user-room-updated')
					this.$store.dispatch('setMessage', {
						message: 'Chat grupal creado exitosamente',
						title: 'Éxito',
						type: 'success',
						icon: 'mdi-check-circle',
						color: '#00C800'
					})
				} else {
					this.$store.dispatch('setMessage', {
						message: 'No fue posible crear el chat grupal. Intenta nuevamente.',
						title: 'Error',
						type: 'danger',
						icon: 'mdi-alert-circle',
						color: '#FF1209'
					})
				}
			} catch (error) {
				console.error('Error al crear chat grupal:', error)
				this.$store.dispatch('setMessage', {
					message: error.message || 'Error desconocido al crear el chat grupal',
					title: 'Error',
					type: 'danger',
					icon: 'mdi-alert-circle',
					color: '#FF1209'
				})
			} finally {
				this.$set(this.isLoading, 'project-chat', false)
			}
		}
	}
}
</script>

<style scoped>
.v-list-item:hover {
	background-color: #f5f5f5;
}

/* Search field compacto */
.search-field.v-text-field--outlined >>> fieldset {
	border-color: #e0e0e0;
}
.search-field >>> .v-input__control .v-input__slot {
	min-height: 30px !important;
	padding: 0 8px !important;
}
.search-field >>> .v-input__prepend-inner {
	margin-top: 4px !important;
}
.search-field >>> input {
	font-size: 11px;
}

/* Segmented control */
.segmented-control {
	display: flex;
	border: 1px solid #d0d0d0;
	border-radius: 5px;
	overflow: hidden;
	width: 100%;
	gap: 0;
}
.seg-btn {
	flex: 1;
	font-size: 12px;
	padding: 6px 4px;
	background: transparent;
	border: none;
	border-right: 1px solid #e0e0e0;
	color: #777;
	cursor: pointer;
	font-family: inherit;
	transition: background 0.12s, color 0.12s;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 3px;
	white-space: nowrap;
	line-height: 1;
	text-align: center;
}
.seg-btn:last-child {
	border-right: none;
}
.seg-btn:hover {
	background: #f5f5f5;
	color: #333;
}
.seg-btn.active {
	background: #524D4D;
	color: white;
}
.seg-count {
	font-size: 12px;
}
</style>